var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ac93f616a0d70bd6bd3d857b798f3701d7ed365b"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["hsd-website@biesse"]={id:"ac93f616a0d70bd6bd3d857b798f3701d7ed365b"};
      